import { FC, useMemo } from "react";

import {
  getStationRouteDisplayStationById,
  IStationRouteWrapperProps,
  useTimezone,
} from "@ryde/shared";

import { StationRouteStation } from "./station-route.station";

export const StationWrapperStationRoute: FC<IStationRouteWrapperProps> = ({
  stationId,
  stationRouteDto,
  stationIndex,
  isLastStation,
  isFirstStation,
  isDragReorderAllowed = true,
}) => {
  const { timezone } = useTimezone();
  const station = useMemo(() => {
    return getStationRouteDisplayStationById({
      stationRouteDto,
      stationId,
      timezone,
    });
  }, [stationRouteDto, stationId, timezone]);
  return (
    station && (
      <StationRouteStation
        station={station}
        stationRouteDto={stationRouteDto}
        isLastStation={isLastStation}
        isFirstStation={isFirstStation}
        stationIndex={stationIndex}
        isDragReorderAllowed={isDragReorderAllowed}
      />
    )
  );
};
